import { Alert, message } from 'antd';
import CustomerGridFilters from './filters';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import apiCalls from 'src/api/apiCalls';
import CustomersGrid from '../customers/grid'
import dayjs from 'dayjs';
import HeaderComponent from '../header';
import ActionsComponent from '../shared/ActionsComponent';
import GridLayout from '../shared/gridLayout';
const Customers = () => {
  const [filterValues, setFilterValues] = useState({ "Status": "All", "freeSearch": null, "startDate": null, "toDate": null });
  const [error, setError] = useState(null);
  const [stateLu, setStateLu] = useState([]);
  const shouldLog = useRef(true);
  const [isExcelExport, setIsExcelExport] = useState(false);
  const [onActionClick, setOnActionClick] = useState(false);
  const refreshRef = useRef();
  const breadCrumbList = [
    { bname: 'Customers' },
  ]
  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getCustomerStatusLu();
    }
  }, [])
  const getCustomerStatusLu = async () => {
    try {
      const response = await apiCalls.getCustomerStateLookups('/KycService/CustomerState');
      if (response) {
        setStateLu(response.data?.CustomerState)
        setError(null)
      }
      else {
        setError(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setError(apiCalls.isErrorDispaly(error))
    }
  }
  const handleSearch = useCallback((values) => {
    let formattedDates = null;
    if (values?.dateRange) {
      formattedDates = values?.dateRange ? values?.dateRange?.map(date => dayjs(date).format('YYYY-MM-DD')) : null
    }
    setFilterValues({
      Status: values?.Status || "All",
      freeSearch: values?.freeSearch,
      startDate: formattedDates ? formattedDates[0] : null,
      toDate: formattedDates ? formattedDates[1] : null,
    });
  }, [])
  const handleExcelExport = useCallback(() => {
    setIsExcelExport(true)
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }, [])
  const handleToolBarActions = useCallback((action) => {
    if (action?.toLowerCase() === 'casesadd') {
      setOnActionClick(true);
    }
    else if (action === 'exportexcel') {
      handleExcelExport()
    }
  }, [handleExcelExport])
  const handleError = useCallback((error) => {
    setError(error);
    setOnActionClick(false);
  }, [])
  const ongridActionClick = useCallback((key) => {
    handleToolBarActions(key)
  }, [])
  const closeErrorHandler = useCallback(() => {
    setError(null)
  }, [])

  return (
    <div className=''>
      <HeaderComponent breadCrumbList={breadCrumbList} />
      <div className='md:flex justify-between mb-4 md:space-y-0 space-y-3'>
        <div>
          <CustomerGridFilters filterObj={handleSearch} filterValues={filterValues} stateLu={stateLu} onloadGrid={refreshRef?.current?.loadGrid} />
        </div>
        <div className='flex justify-end gap-2'>
          <ActionsComponent serviceName={"CardsManageService.Customers"} onActionClick={ongridActionClick} />
          <GridLayout />
        </div>
      </div>
      {error &&
        <Alert
          className='mb-2'
          type="error"
          description={error}
          onClose={closeErrorHandler}
          showIcon
          closable
        />
      }
      <CustomersGrid filterValues={filterValues} ref={refreshRef} isExcelExport={isExcelExport} onActionClick={onActionClick} setError={handleError} />
    </div>
  )
}
export default React.memo(Customers);